import { IonContent } from '@ionic/react';
import React from 'react';

const TicketsView: React.FC = () => {
	return <IonContent></IonContent>;
};

export default TicketsView;
